import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  LayoutDashboard, 
  Package, 
  FolderOpen, 
  Users, 
  UserCheck, 
  FileText, 
  Calendar,
  CalendarRange,
  CalendarDays,
  Settings,
  LogOut,
  Calculator
} from 'lucide-react';
import { cn } from '../../lib/utils';
import { useAuth } from '../../contexts/AuthContext';
import { Button } from '../ui/button';

const Sidebar = () => {
  const location = useLocation();
  const { user, logout } = useAuth();
  
  const isOwner = user?.role === 'owner';

  const menuItems = [
    { path: '/', icon: LayoutDashboard, label: 'Dashboard' },
    { path: '/equipment', icon: Package, label: 'Apparatuur' },
    { path: '/projects', icon: FolderOpen, label: 'Projecten' },
    { path: '/customers', icon: Users, label: 'Klanten' },
    { path: '/crew', icon: UserCheck, label: 'Personeel' },
    { path: '/invoicing', icon: FileText, label: 'Facturatie' },
    { path: '/calendar', icon: Calendar, label: 'Agenda' },
    { path: '/equipment-calendar', icon: CalendarRange, label: 'Apparatuur Besch.' },
    { path: '/crew-calendar', icon: CalendarDays, label: 'Personeel Besch.' },
    { path: '/bookkeeping', icon: Calculator, label: 'Boekhouding', ownerOnly: true },
  ];

  return (
    <div className="w-64 bg-gradient-to-b from-slate-900 to-slate-800 text-white h-screen fixed left-0 top-0 flex flex-col shadow-xl">
      <div className="p-6 border-b border-slate-700">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gradient-to-br from-blue-500 via-purple-500 to-blue-600 rounded-lg flex items-center justify-center font-bold text-xl shadow-lg">
            VS
          </div>
          <div>
            <h1 className="text-lg font-bold tracking-tight">Van Vessem</h1>
            <p className="text-xs text-slate-400">Sound & Lights</p>
          </div>
        </div>
      </div>

      <nav className="flex-1 p-4 space-y-1 overflow-y-auto">
        {menuItems.map((item) => {
          // Hide owner-only items from non-owners
          if (item.ownerOnly && !isOwner) {
            return null;
          }
          
          const Icon = item.icon;
          const isActive = location.pathname === item.path;
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className={cn(
                'flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200',
                isActive
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg transform scale-105'
                  : 'text-slate-300 hover:bg-slate-700/50 hover:text-white'
              )}
            >
              <Icon className="w-5 h-5" />
              <span className="font-medium">{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="p-4 border-t border-slate-700">
        <div className="mb-3 px-4 py-3 bg-slate-700/50 rounded-lg">
          <p className="text-xs text-slate-400">Ingelogd als</p>
          <p className="text-sm font-medium text-white truncate">{user?.email}</p>
          <p className="text-xs text-slate-400 mt-1 capitalize">{user?.role === 'owner' ? 'Eigenaar' : 'Medewerker'}</p>
        </div>
        <Link
          to="/settings"
          className={cn(
            'flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-200 mb-2',
            location.pathname === '/settings'
              ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg transform scale-105'
              : 'text-slate-300 hover:bg-slate-700/50 hover:text-white'
          )}
        >
          <Settings className="w-5 h-5" />
          <span className="font-medium">Instellingen</span>
        </Link>
        <Button
          onClick={logout}
          variant="ghost"
          className="w-full flex items-center space-x-3 px-4 py-3 text-slate-300 hover:bg-slate-700/50 hover:text-white transition-all duration-200"
        >
          <LogOut className="w-5 h-5" />
          <span className="font-medium">Uitloggen</span>
        </Button>
      </div>
    </div>
  );
};

export default Sidebar;
